import {createStore, applyMiddleware} from "redux";
import {createLogger} from "redux-logger";
import rootReducer from "store/reducers";

function configure() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    let isLogVisible = true;

    window.addEventListener("keydown", event => {
      if (event.code === "KeyL") {
        isLogVisible = !isLogVisible;
        return;
      }
    });

    const logger = createLogger({
      predicate: (getState, action) => isLogVisible === true,
    });

    return createStore(rootReducer, applyMiddleware(logger));
  } else {
    return createStore(rootReducer);
  }
}

export const store = configure();
